import { commands as notificationCommands } from '../../../tauri/plugins/notification';

export type EnablePushOutcome =
  | 'granted'
  | 'denied'
  | 'needs-settings'
  | 'unavailable';

const REQUEST_SETTLE_MS = 500;

export async function ensureDesktopPushPermission(): Promise<EnablePushOutcome> {
  try {
    const current = await notificationCommands.checkNotificationPermission();
    if (current === 'Granted') return 'granted';
    if (current === 'NotGrantedAndShouldRequest') {
      await notificationCommands.requestNotificationPermission();
      await new Promise(resolve => setTimeout(resolve, REQUEST_SETTLE_MS));
      const requested = await notificationCommands.checkNotificationPermission();
      return requested === 'Granted' ? 'granted' : 'denied';
    }
    await notificationCommands.openNotificationSettings();
    return 'needs-settings';
  } catch {
    return 'unavailable';
  }
}
